export default __webpack_public_path__ + "static/media/sportsman_02.eec1bb19.jpeg";